import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { TakeawayPopup } from 'components/TakeawayPopup';
import { isScreenBelow800, isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import {
  sendPickupBuy,
  setViewPickupBuy,
  togglePickupBuy,
} from 'store/ProductDetails/common/actions';
import {
  getDeliveryPickupBuyData,
  getDeliveryPickupBuyErrorDetails,
  getDeliveryPickupBuyLoading,
  getDeliveryPickupBuyOpenState,
  getDeliveryPickupBuyPoint,
  getDeliveryPickupBuySuccess,
  getDeliveryPickupBuyViewState,
  getDeliveryTakeawayViews,
  getDetailsDevicePlusFinalHeader,
  getDetailsDevicePlusFinalText,
  getDetailsESimSPButton,
  getDetailsESimSPText,
  getDetailsESimSPUrl,
  getEsimAvailable,
} from 'store/ProductDetails/selectors';

import { TakeawayPopupControls, TakeawayPopupFilters, TakeawayPopupRouter } from './components';
import styles from './styles.pcss';

const cx = classNames.bind({ ...styles });

const DetailsTakeawayPopup = ({
  data,
  errorDetails,
  finalHeader,
  finalText,
  hasEsim,
  isLoading,
  isMobile,
  isOpen,
  isTablet,
  point,
  sendData,
  setViewState,
  spMessageButtonText,
  spMessageButtonUrl,
  spMessageText,
  successData,
  tabs,
  togglePickup,
  viewState,
}) => {
  return (
    <TakeawayPopup
      reload
      {...{
        data,
        errorDetails,
        finalHeader,
        finalText,
        hasEsim,
        isLoading,
        isMobile,
        isOpen,
        isTablet,
        point,
        sendData,
        setViewState,
        spMessageButtonText,
        spMessageButtonUrl,
        spMessageText,
        successData,
        togglePickup,
        viewState,
      }}
    >
      <TakeawayPopupControls {...{ tabs }} className={cx(isMobile && 'explicitControls')} />
      <TakeawayPopupFilters />
      <TakeawayPopupRouter
        {...{ tabs }}
        classForList={cx('pickupbuyList', isMobile && 'mobile')}
        classForMap={cx('pickupbuyMap', isMobile && 'mobile')}
        idForMap="pickbuy_map"
      />
    </TakeawayPopup>
  );
};

DetailsTakeawayPopup.propTypes = {
  children: PropTypes.node,
  data: PropTypes.shape({
    agreementContent: PropTypes.string,
    buttonText: PropTypes.string,
    description: PropTypes.string,
    headline: PropTypes.string,
    propsContent: PropTypes.string,
  }),
  errorDetails: PropTypes.shape({
    headline: PropTypes.string,
    message: PropTypes.string,
  }),
  finalHeader: PropTypes.any,
  finalText: PropTypes.any,
  hasEsim: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  isTablet: PropTypes.bool,
  point: PropTypes.object,
  sendData: PropTypes.func,
  setViewState: PropTypes.func,
  spMessageButtonText: PropTypes.string,
  spMessageButtonUrl: PropTypes.string,
  spMessageText: PropTypes.string,
  successData: PropTypes.shape({
    name: PropTypes.string,
    orderId: PropTypes.string,
    phone: PropTypes.string,
    pointAddress: PropTypes.string,
    pointOpening: PropTypes.string,
    price: PropTypes.number,
    title: PropTypes.string,
  }),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  togglePickup: PropTypes.func,
  viewState: PropTypes.string,
};

const mapStateToProps = (state) => ({
  data: getDeliveryPickupBuyData(state),
  errorDetails: getDeliveryPickupBuyErrorDetails(state),
  finalHeader: getDetailsDevicePlusFinalHeader(state),
  finalText: getDetailsDevicePlusFinalText(state),
  hasEsim: getEsimAvailable(state),
  isLoading: getDeliveryPickupBuyLoading(state),
  isMobile: isScreenBelow800(state),
  isOpen: getDeliveryPickupBuyOpenState(state),
  isTablet: isScreenBelow1004(state),
  point: getDeliveryPickupBuyPoint(state),
  spMessageButtonText: getDetailsESimSPButton(state),
  spMessageButtonUrl: getDetailsESimSPUrl(state),

  spMessageText: getDetailsESimSPText(state),
  successData: getDeliveryPickupBuySuccess(state),
  tabs: getDeliveryTakeawayViews(state), // for TakeawayViewRouter, TakeawayPopupControls
  viewState: getDeliveryPickupBuyViewState(state),
});

const mapDispatchToProps = {
  sendData: sendPickupBuy,
  setViewState: setViewPickupBuy,
  togglePickup: togglePickupBuy,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTakeawayPopup);
